<template>
  <v-container fluid :class="{'px-0':esMovil}">
    <v-row no-gutters align="center" justify="center">
      <v-col cols="12" md="10" lg="8" xl="8">
        <v-tabs v-model="tab" background-color="primary" color="white" dark :class="{'elevation-1':!esMovil}"
                :grow="true">
          <v-tabs-slider color="secondary"/>

          <v-tab v-for="iTab in tabs" :key="iTab.id" :href="`#tab-${iTab.id}`">
            {{ $tc(iTab.name, 1) }}
          </v-tab>

          <v-tab-item :value="'tab-' + tabs[0].id">
            <v-row class="pa-4" no-gutters>
              <v-col>
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <perfil-editar-component v-model="modeloPerfilValido"
                                             :perfil.sync="modeloPerfil" :email-editable="false"/>
                    <politica-privacidad-component v-show="!usuarioTeniaAceptadaPolitica"
                                                   v-model="politica_aceptada"/>
                  </v-col>
                </v-row>
                <v-row align="center" justify="end" no-gutters>
                  <v-col cols="12" class="text-end">
                    <v-btn color="primary" depressed
                           :disabled="!perfilValido || cargandoPerfil"
                           :loading="actualizandoPerfil"
                           @click="actualizarPerfil()">
                      <span class="mr-2">{{ $t('guardar') | capitalize }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item :value="'tab-' + tabs[1].id">
            <v-row class="pa-4" no-gutters>
              <v-col>
                <v-row align="center" justify="center">
                  <v-col>
                    <v-text-field :label="$t('label_contrasenya_actual')"
                                  v-model="contrasenya_actual" type="password" :rules="[requerido]"
                                  prepend-inner-icon="mdi-lock"/>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col>
                    <v-text-field :label="$t('label_contrasenya')" v-model="contrasenya_nueva"
                                  type="password" :rules="[requerido, counter6]"
                                  prepend-inner-icon="mdi-lock"/>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col>
                    <v-text-field :label="$t('label_contrasenya_confirmacion')"
                                  v-model="contrasenya_confirmacion"
                                  :rules="[requerido, contrasenyaConfirmacion]" type="password"
                                  prepend-inner-icon="mdi-lock"/>
                  </v-col>
                </v-row>
                <v-row align="center" justify="end" no-gutters>
                  <v-col cols="12" class="text-end">
                    <v-btn color="primary" depressed :disabled="!contrasenyaValida()"
                           :loading="actualizandoContrasenya" @click="cambiarContrasenya()">
                      <span class="mr-2">{{ $t('cambiar') | capitalize }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";
import PerfilEditarComponent from "@/components/PerfilEditarComponent";
import PoliticaPrivacidadComponent from "@/components/PoliticaPrivacidadComponent";

export default {
  name: 'RegistroPagina',
  components: {PerfilEditarComponent, PoliticaPrivacidadComponent},
  data: () => ({
    tab: null,
    tabs: [
      {id: "perfil", name: "perfil"},
      {id: "contrasenya", name: "contrasenya"}
    ],
    modeloPerfilValido: false,
    modeloPerfil: {
      usuario: "",
      nombre: "",
      empresa: "",
      cargo: "",
      tipo: ""
    },
    usuarioTeniaAceptadaPolitica: true,
    politica_aceptada: false,
    contrasenya_actual: "",
    contrasenya_nueva: "",
    contrasenya_confirmacion: "",
    cargandoPerfil: false,
    actualizandoPerfil: false,
    actualizandoContrasenya: false,
  }),
  computed: {
    perfilValido() {
      if (!this.politica_aceptada) return false;

      return this.modeloPerfilValido;
    },
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  mounted() {
    this.cargarPerfil();
  },
  methods: {
    requerido(value) {
      return !!value || this.$tc('requerido', 1)
    },
    counter6(value) {
      return value.length >= 6 || this.$t('minimo6')
    },
    contrasenyaConfirmacion(confirmacion) {
      return this.contrasenya_nueva == confirmacion || this.$t('contr_coin');
    },
    contrasenyaValida() {
      if (this.contrasenya_actual.length <= 0) return false;
      if (this.contrasenya_nueva.length <= 0) return false;
      if (this.contrasenya_confirmacion.length <= 0) return false;

      if (this.contrasenya_nueva != this.contrasenya_confirmacion) return false;

      return true;
    },
    cargarPerfil() {
      this.cargandoPerfil = true;
      HttpHelper.get("auth/info-usuario")
          .then((res) => {
            this.usuarioTeniaAceptadaPolitica = res.isPoliticaAceptada;
            this.modeloPerfil.usuario = res.usuario;
            this.modeloPerfil.nombre = res.nombre;
            this.modeloPerfil.empresa = res.empresa;
            this.modeloPerfil.cargo = res.cargo;
            this.modeloPerfil.tipo = res.tipo.codigo;
            this.politica_aceptada = res.isPoliticaAceptada;
          })
          .finally(() => {
            this.cargandoPerfil = false;
          });
    },
    actualizarPerfil() {
      let params = {
        nombre: this.modeloPerfil.nombre,
        empresa: this.modeloPerfil.empresa,
        cargo: this.modeloPerfil.cargo,
        tipo: this.modeloPerfil.tipo,
        politica_aceptada: this.politica_aceptada
      };
      this.actualizandoPerfil = true;
      HttpHelper.post("auth/actualizar-perfil", params)
          .then(() => {
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: this.$t('perfil_actualizado_msg'),
              color: "success"
            });
            this.cargarPerfil();
          })
          .catch((error) => {
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                  ? error.mensaje : this.$t('error_perfil'),
              color: "error"
            });
          })
          .finally(() => {
            this.actualizandoPerfil = false;
          })
    },
    cambiarContrasenya() {
      let params = {
        contrasenyaActual: this.contrasenya_actual,
        contrasenya: this.contrasenya_nueva,
        contrasenya_confirmacion: this.contrasenya_confirmacion
      };

      this.actualizandoContrasenya = true;
      HttpHelper.post("auth/cambiar-contrasenya", params)
          .then(() => {
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: this.$t('contrasenya_cambiada_msg'),
              color: "success"
            });
          })
          .catch((error) => {
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                  ? error.mensaje : this.$t('error_contrasenya'),
              color: "error"
            });
          })
          .finally(() => {
            this.actualizandoContrasenya = false;
            this.contrasenya_actual = "";
            this.contrasenya_nueva = "";
            this.contrasenya_confirmacion = "";
          });
    }
  }
};
</script>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "label_contrasenya_actual": "Contraseña actual",
    "label_contrasenya": "Nueva contraseña",
    "label_contrasenya_confirmacion": "Repite la nueva contraseña",
    "minimo6": "Mínimo 6 carácteres",
    "contr_coin": "Las contraseñas deben coincidir",
    "error_perfil": "Ha ocurrido un error al actualizar el perfil",
    "perfil_actualizado_msg": "Perfil actualizado correctamente",
    "contrasenya_cambiada_msg": "Contraseña cambiada correctamente",
    "error_contrasenya": "Ha ocurrido un error al cambiar la contraseña",
    "acepto_politica": "Acepto la política de protección de datos"
  }
}
</i18n>
<!-- @formatter:on -->